import { create } from "zustand";

const getInitialUserSelections = () => {
  const userSelections = localStorage.getItem("userSelections");

  if (userSelections) {
    return JSON.parse(userSelections);
  }

  return {
    selectedColumns: ["title", "id", "groupId", "dataType", "accessType"],
  };
};

const userSelectionsStore = create<{
  userSelections: { selectedColumns: string[] };
  setUserSelections: (selectedColumns: string[]) => void;
}>(set => ({
  userSelections: getInitialUserSelections(),
  setUserSelections: selectedColumns => {
    set(state => {
      const updatedUserSelections = {
        ...state.userSelections,
        selectedColumns,
      };

      localStorage.setItem("userSelections", JSON.stringify(updatedUserSelections));

      return { userSelections: updatedUserSelections };
    });
  },
}));

export default userSelectionsStore;
